import type { CandidateWorkFeedFormFilter } from '@axiom/validation';
import { useApi, TaxonomyUtil } from '@axiom/ui';

import { WorkFeedFilterUtil } from '../../utils/work-feed-filter-util';
import type { FilterPill } from '../../types/work-feed.types';
import { TaxonomyApi } from '../../api/taxonomy-api';

const {
  countryOptions,
  engagementLengthOptions,
  opportunityStageOptions,
  weeklyCommitmentOptions,
  worksiteOptions,
} = WorkFeedFilterUtil;
export const useWorkFeedFilterPills = (
  filters: CandidateWorkFeedFormFilter
) => {
  const pills: FilterPill[] = [];

  const [{ data: taxonomy }] = useApi(TaxonomyApi.readTaxonomy());
  const practiceAreaOptions = TaxonomyUtil.getPracticeAreaOptions(
    taxonomy.practiceAreas
  );
  const focusAreaOptions = TaxonomyUtil.getFocusAreaOptions(
    taxonomy.focusAreas
  );
  const industryOptions = TaxonomyUtil.getFilteredIndustryOptions(
    taxonomy.industries
  );
  const legalRoleOptions = TaxonomyUtil.getBusinessTitleOptions(
    taxonomy.businessTitles
  );

  const config = [
    { name: 'opportunityPhases', options: opportunityStageOptions },
    { name: 'practiceAreas', options: practiceAreaOptions },
    { name: 'focusAreas', options: focusAreaOptions },
    { name: 'industries', options: industryOptions },
    { name: 'timeCommitment', options: weeklyCommitmentOptions },
    { name: 'countries', options: countryOptions },
    { name: 'worksites', options: worksiteOptions },
    { name: 'engagementLength', options: engagementLengthOptions },
    { name: 'businessTitles', options: legalRoleOptions },
  ] as const;

  config.forEach(({ name, options }) => {
    const filter = filters[name];
    if (filter) {
      filter.forEach(v => {
        const matchingOption = options.find(opt => opt.value === v);
        if (matchingOption) {
          pills.push({ ...matchingOption, name });
        }
      });
    }
  });

  return pills;
};
